import { render, staticRenderFns } from "./Accomodations.vue?vue&type=template&id=5aaeb60e"
import script from "./Accomodations.vue?vue&type=script&lang=js"
export * from "./Accomodations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports